<div class="view-container" *ngIf="video_url !== null">
    <ze-video id="video" 
  [filename]=video_url [videoContent]="true" [username]="user"></ze-video>
</div>
<div class="loader-container" *ngIf="video_url == null && !videoNotFound">
  <div class="report-loader"></div>
</div>
<div class="container" *ngIf="videoNotFound">
    <div class="row">
        <div class="col-sm-12 center input-container-box">
            <img src="../../../assets/images/error-cross.png" alt="Error" class="error-image">
            <h3>Link Invalid or Video Not Found</h3>
        </div>
    </div>
</div>
